export function createNavbarHomeSetupEffect({ store }) {
  let refs = null;

  function mount() {
    const bodyBack = document.getElementsByTagName("body")[0];
    const body = document.querySelector("div.app-content.content");
    const headerShadow = document.getElementsByClassName("header-navbar-shadow")[0];
    const navbar = document.getElementsByClassName("header-navbar")[0];
    const navInner = document.getElementsByClassName("navbar-container")[0];

    refs = { bodyBack, body, headerShadow, navbar, navInner };

    if (bodyBack) bodyBack.style.backgroundColor = "white";
    if (store) store.commit("appConfig/UPDATE_NAV_MENU_HIDDEN", true);

    if (headerShadow) headerShadow.style.setProperty("display", "none");
    if (body) body.style.setProperty("padding", "0px", "important");
    if (navbar) navbar.classList.add("tranparent-background-nav");
    if (navInner) navInner.classList.add("tranparent-background-nav");
  }

  function unmount() {
    if (!refs) return;

    const { bodyBack, body, headerShadow, navbar, navInner } = refs;

    if (bodyBack) bodyBack.removeAttribute("style");
    if (store) store.commit("appConfig/UPDATE_NAV_MENU_HIDDEN", false);

    if (navbar) {
      navbar.classList.remove("tranparent-background-nav");
      navbar.classList.remove("out-animation-nav");
      navbar.classList.remove("in-animation-nav");
    }
    if (navInner) navInner.classList.remove("tranparent-background-nav");
    if (headerShadow) headerShadow.removeAttribute("style");
    if (body) body.removeAttribute("style");

    refs = null;
  }

  return { mount, unmount };
}
